import { createUseStyles } from 'react-jss';
import { theme } from '@align-cpf/uikit-styles';

export default createUseStyles(
  {
    root: {
      position: 'relative',
      display: 'inline-block',
    },

    content: {
      background: theme.colors.backgroundInverse,
      color: theme.colors.textInverse,
      padding: theme.spacing.sp02,
      borderRadius: 4,
      font: theme.typography.tpBody01,
      position: 'absolute',
      pointerEvents: 'none',
      width: 'max-content',
      opacity: 0,
      zIndex: 1,
    },

    open: {
      opacity: 1,
    },

    'content-top': {
      bottom: `calc(100% + ${theme.spacing.sp02})`,

      '&$start': {
        right: `calc(50% - ${theme.spacing.sp02})`,
      },

      '&$center': {
        left: '50%',
        transform: 'translateX(-50%)',
      },

      '&$end': {
        left: `calc(50% - ${theme.spacing.sp02})`,
      },
    },

    'content-right': {
      left: `calc(100% + ${theme.spacing.sp02})`,

      '&$start': {
        bottom: `calc(50% - ${theme.spacing.sp02})`,
      },

      '&$center': {
        top: '50%',
        transform: 'translateY(-50%)',
      },

      '&$end': {
        top: `calc(50% - ${theme.spacing.sp02})`,
      },
    },

    'content-bottom': {
      top: `calc(100% + ${theme.spacing.sp02})`,

      '&$start': {
        right: `calc(50% - ${theme.spacing.sp02})`,
      },

      '&$center': {
        left: '50%',
        transform: 'translateX(-50%)',
      },

      '&$end': {
        left: `calc(50% - ${theme.spacing.sp02})`,
      },
    },

    'content-left': {
      right: `calc(100% + ${theme.spacing.sp02})`,

      '&$start': {
        bottom: `calc(50% - ${theme.spacing.sp02})`,
      },

      '&$center': {
        top: '50%',
        transform: 'translateY(-50%)',
      },

      '&$end': {
        top: `calc(50% - ${theme.spacing.sp02})`,
      },
    },

    arrow: {
      position: 'absolute',
      width: 0,
      height: 0,
      borderStyle: 'solid',
      borderWidth: 8,
      borderColor: 'transparent',
    },

    'arrow-top': {
      borderBottomWidth: 0,
      borderTopColor: theme.colors.backgroundInverse,
      top: 'calc(100% - 4px)',

      '&$start': {
        right: 0,
      },

      '&$center': {
        left: '50%',
        transform: 'translateX(-50%)',
      },

      '&$end': {
        left: 0,
      },
    },

    'arrow-right': {
      borderLeftWidth: 0,
      borderRightColor: theme.colors.backgroundInverse,
      right: 'calc(100% - 4px)',

      '&$start': {
        bottom: 0,
      },

      '&$center': {
        top: '50%',
        transform: 'translateY(-50%)',
      },

      '&$end': {
        top: 0,
      },
    },

    'arrow-bottom': {
      borderTopWidth: 0,
      borderBottomColor: theme.colors.backgroundInverse,
      bottom: 'calc(100% - 4px)',
      '&$start': {
        right: 0,
      },

      '&$center': {
        left: '50%',
        transform: 'translateX(-50%)',
      },

      '&$end': {
        left: 0,
      },
    },

    'arrow-left': {
      borderRightWidth: 0,
      borderLeftColor: theme.colors.backgroundInverse,
      left: 'calc(100% - 4px)',

      '&$start': {
        bottom: 0,
      },

      '&$center': {
        top: '50%',
        transform: 'translateY(-50%)',
      },

      '&$end': {
        top: 0,
      },
    },

    start: {},
    end: {},
    center: {},
  },
  {
    name: 'Tooltip',
  },
);
